import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { DefaultFormToolBar } from '../../../components/toolbar/DefaultFormToolBar'
import { icons, routes } from '../../../constants'
import { actions } from '../produto.actions'
import { ProdutoForm } from './ProdutoForm'
import utils, { getMessage } from '../../../utils'
import _ from 'lodash'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import LtsInputText from '../../../components/lottus/lts-input-text'
import { logarAcesso } from '../../../services/api-log-acesso'
import storage from '../../../services/stoage.service'
import AjustarEstoque from '../ajustar-estoque'
import TransferirEstoque from '../transferir-estoque'

const mapStateToProps = (state) => {
  const unidades = utils.getListIdValuesUnidadeDisponiveisUsuario()
  const adicionandoAnexo = state.crudProdutoState.adicionandoAnexo
  const currentCompany = storage.getCompany()
  const isMovimentoEstoqueAtivo = utils.isMovimentoEstoqueAtivo(currentCompany, null)
  return {
    record: state.crudProdutoState.currentRecord,
    messages: state.crudProdutoState.messages,
    unidades,
    colunasFornecedores: state.crudProdutoState.colunasFornecedores,
    colunasEstoque: state.crudProdutoState.colunasEstoque,
    stateMarcador: state.crudMarcadorState,
    adicionandoAnexo,
    isMovimentoEstoqueAtivo,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setField: (field, value) => dispatch(actions.setField(field, value)),
    saveHandler: (event) => {
      dispatch(actions.save())
    },
    removeHandler: (event) => {
      dispatch(actions.remove())
    },
    newHandler: (event) => {
      dispatch(actions.makeNew())
    },
    loadById: (oid) => dispatch(actions.loadById(oid)),
    addAnexo(anexo) {
      dispatch(actions.processaAnexo(anexo))
    },
    removeAnexo(anexo) {
      dispatch(actions.removeAnexo(anexo))
    },
    downloadAnexo(anexo) {
      dispatch(actions.downloadAnexo(anexo))
    },
    inventariarEstoque: ({ params, oidRecord }) => dispatch(actions.inventariarEstoque({ params, oidRecord })),
    transferirEstoque: ({ params, oidRecord }) => dispatch(actions.transferirEstoque({ params, oidRecord })),
  }
}

class ProdutoFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: 0,
      showDialogRemove: false,
      showAjustarEstoque: false,
      showTransferirEstoque: false,
      selectedProdutoUnidade: null,
    }

    actions.afterSave = ({ oid }) => {
      this.props.history.replace(`${routes.PATH_PRODUTO}/${oid}`)
    }
    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_PRODUTO}/novo`)
    }
    actions.afterRemove = () => {
      this.props.history.replace(`${routes.PATH_PRODUTO}`)
    }

    actions.beforeFetchRecordSuccess = (data) => {
      if (!data.unidade) {
        data.unidade = { id: -1, value: `<Todas>` }
      }
      return data
    }
  }

  componentDidMount() {
    const oidEntity = _.get(this, 'props.match.params.id', null)
    logarAcesso(oidEntity).then()
    if (oidEntity && parseInt(oidEntity)) {
      this.props.loadById(oidEntity)
    } else {
      this.props.newHandler()
    }
  }

  searchHandler = () => {
    this.props.history.push(`${routes.PATH_PRODUTO}`)
  }

  hideDialog = () => {
    this.setState({ showDialogRemove: false })
    this.setState({ showAjustarEstoque: false })
    this.setState({ showTransferirEstoque: false })
    this.setState({ selectedProdutoUnidade: undefined })
  }

  buildHeader = () => {
    return <DefaultFormToolBar formPageContainer={this} />
  }

  removerFornecedor = (fornecedorRemovido) => {
    const fornecedoresRestantes = this.props.record.fornecedores.filter((fornecedor) => {
      return fornecedor.oid !== fornecedorRemovido.oid
    })
    this.props.setField('fornecedores', fornecedoresRestantes)
  }

  onChangeFornecedor = (data) => {
    const fornecedores = this.props.record.fornecedores || []
    fornecedores.push({
      oidFornecedor: data.oid,
      nomeFornecedor: data.nome,
      documentoFornecedor: data.numeroDocumento,
    })
    this.props.setField('fornecedores', fornecedores)
  }

  onInputFilterFornecedor = (data) => {
    const value = data.value
    if (typeof value === 'string') {
      this.props.setField('fornecedor', { nome: data, oid: null })
    } else {
      const fornecedores = this.props.record.fornecedores || []
      fornecedores.push({
        oidFornecedor: value.oid,
        nomeFornecedor: value.nome,
        documentoFornecedor: value.numeroDocumento,
      })
      this.props.setField('fornecedores', fornecedores)
      this.props.setField('fornecedor', { nome: null, oid: null })
    }
  }

  onChangeTableValue = (rowData, value, field) => {
    rowData[field] = value
    this.props.setField('fornecedores', this.props.record.fornecedores)
  }

  actionFornecedor = (rowData) => {
    return (
      <div>
        <Button
          type="button"
          icon={icons.REMOVE_ICON}
          className="p-button-danger"
          onClick={(e) => this.removerFornecedor(rowData)}
        />
      </div>
    )
  }

  setMarcadores = (data) => {
    const values = []
    data.forEach((object) => {
      values.push({
        id: _.get(object, 'oid', ''),
        value: _.get(object, 'codigo', ''),
      })
    })
    this.props.setField('marcadores', values)
  }

  changeActiveIndex = (index) => {
    this.setState({ activeIndex: index })
  }

  getDialogAjustarEstoque = () => {
    if (this.state.showAjustarEstoque) {
      return (
        <AjustarEstoque
          visible={this.state.showAjustarEstoque}
          labelSaldo={getMessage(this.props.messages, 'produto.label.novoSaldo')}
          labelValor={getMessage(this.props.messages, 'produto.label.novoValor')}
          labelConfirmar={getMessage(this.props.messages, 'produto.label.confirmar')}
          labelAjustar={getMessage(this.props.messages, 'produto.label.ajustarEstoque')}
          data={this.state.selectedProdutoUnidade}
          onConfirm={this.onClickConfirmarAjustarEstoque}
          onHide={this.hideDialog}
        />
      )
    }
    return null
  }

  onClickAjustarEstoque = (rowData) => {
    this.setState({ selectedProdutoUnidade: rowData })
    this.setState({ showAjustarEstoque: true })
  }

  onClickConfirmarAjustarEstoque = (data) => {
    const unidade = _.get(data, 'produtoUnidade.unidade', null)
    const produto = _.get(data, 'produtoUnidade.produto', null)
    const quantidade = _.get(data, 'saldo', null)
    const valor = _.get(data, 'valor', null)
    this.props.inventariarEstoque({
      params: [{ unidade, produto, quantidade, valor }],
      oidRecord: this.props.record.oid,
    })
    this.hideDialog()
  }

  getDialogTransferirEstoque = () => {
    if (this.state.showTransferirEstoque) {
      return (
        <TransferirEstoque
          messages={this.props.messages}
          visible={this.state.showTransferirEstoque}
          data={this.state.selectedProdutoUnidade}
          onConfirm={this.onClickConfirmarTransferirEstoque}
          onHide={this.hideDialog}
        />
      )
    }
    return null
  }

  onClickTransferirEstoque = (rowData) => {
    this.setState({ selectedProdutoUnidade: rowData })
    this.setState({ showTransferirEstoque: true })
  }

  onClickConfirmarTransferirEstoque = (data) => {
    const unidadeOrigem = _.get(data, 'produtoUnidade.unidade', null)
    const unidadeDestino = _.get(data, 'unidadeDestino', null)
    const produto = _.get(data, 'produtoUnidade.produto', null)
    const quantidade = _.get(data, 'quantidade', null)
    this.props.transferirEstoque({
      params: [
        {
          unidadeOrigem,
          unidadeDestino,
          produto,
          quantidade,
        },
      ],
      oidRecord: this.props.record.oid,
    })
    this.hideDialog()
  }

  render() {
    const columnCodigoFornecedor = (rowData, column) => {
      if (column && column.field === 'codigo') {
        const value = _.get(rowData, column.field, '')
        return (
          <LtsInputText
            value={value}
            onChange={(e) => this.onChangeTableValue(rowData, e, column.field)}
            name="codigo"
            maxLength={50}
            style={{ height: '30px' }}
          />
        )
      }
    }

    const colunasFornecedor = _.get(this, 'props.colunasFornecedores', []).map((col) => {
      col.showFilterMenuOptions = false
      col.showClearButton = false
      col.showFilterMenu = false
      if (col.field === 'acoes') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.actionFornecedor}
            style={{ width: '10em', textAlign: 'center' }}
          />
        )
      } else if (col.field === 'codigo') {
        return <Column {...col} key={col.field} body={columnCodigoFornecedor} />
      } else if (col.field !== 'oid') {
        return <Column {...col} key={col.field} field={col.field} header={col.header} style={{ textAlign: 'left' }} />
      }
    })

    const colunasEstoque = _.get(this, 'props.colunasEstoque', [])
      .filter((col) => col.visible)
      .map((col) => {
        const actions = (rowData) => {
          return (
            <div>
              <Button
                type="button"
                tooltip={getMessage(this.props.messages, 'produto.label.ajustar') || 'Ajustar'}
                onClick={(e) => this.onClickAjustarEstoque(rowData)}
                style={{ width: '35px', marginRight: '10px' }}
                icon={icons.PENCIL_ICON}
              />
              <Button
                type="button"
                tooltip={getMessage(this.props.messages, 'produto.label.transferir') || 'Transferir'}
                onClick={(e) => this.onClickTransferirEstoque(rowData)}
                style={{ width: '35px', marginLeft: '10px' }}
                icon={icons.REPLY_ICON}
              />
            </div>
          )
        }

        const columnData = (rowData, column) => {
          if (column) {
            if (column.field === 'unidade') {
              const idValue = _.get(rowData, column.field, '')
              return <span>{idValue.value}</span>
            }
            if (column.field === 'saldo') {
              const value = _.get(rowData, column.field, '')
              return <span>{value}</span>
            }
            if (column.field === 'valor') {
              const value = _.get(rowData, column.field, '')
              return <span>{utils.formatarDinheiro(value)}</span>
            }
          }
        }

        col.showFilterMenuOptions = false
        col.showClearButton = false
        col.showFilterMenu = false
        if (col.field === 'acoes') {
          return <Column {...col} key={col.field} body={actions} style={{ width: '30%', textAlign: 'right' }} />
        }
        if (col.field === 'unidade' || col.field === 'saldo' || col.field === 'valor') {
          const width = col.field === 'unidade' ? '60%' : '10%'
          return <Column {...col} key={col.field} body={columnData} style={{ width }} />
        }

        return null
      })

    const content = (
      <div>
        {this.getDialogAjustarEstoque()}
        {this.getDialogTransferirEstoque()}
        <ProdutoForm
          state={this.state}
          record={this.props.record}
          messages={this.props.messages}
          unidades={this.props.unidades}
          setField={this.props.setField}
          colunasFornecedor={colunasFornecedor}
          onChangeFornecedor={this.onChangeFornecedor}
          onInputFilterFornecedor={this.onInputFilterFornecedor}
          setMarcadores={this.setMarcadores}
          stateMarcador={this.props.stateMarcador}
          removeAnexo={this.props.removeAnexo}
          anexos={this.props.record.anexos}
          onSelectAnexo={this.props.addAnexo}
          downloadAnexo={this.props.downloadAnexo}
          changeActiveIndex={this.changeActiveIndex}
          isMovimentoEstoqueAtivo={this.props.isMovimentoEstoqueAtivo}
          colunasEstoque={colunasEstoque}
        />
      </div>
    )

    return <Page header={this.buildHeader()} content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProdutoFormPageContainer)
